import { styled } from 'styled-components';

import Logo from 'components/Logo';
import Menus from './components/Menus';
import Grade from './components/Grade';
import { Link } from 'react-router-dom';
import { sidePadding } from 'styles/commonStyles';

const Container = styled.aside`
  height: 100vh;
  position: sticky;
  top: 0;
  padding-top: 32px;
  width: 300px;
  background-color: ${(props) => props.theme.global.bgColor};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0px 0px 10px -6px #a0a0a0;
  z-index: 1000;
`;

const TopView = styled.div`
  ${sidePadding};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const SideBar = () => {
  return (
    <Container>
      <TopView>
        <Link to="/">
          <Logo hasBetaTag />
        </Link>
        <Menus />
      </TopView>
      <Grade></Grade>
    </Container>
  );
};

export default SideBar;
